import {HStack, Text, VStack} from 'platform/foundation';
import {css} from 'styled-components';

import {useLayoutEffect, useRef, useState} from 'react';

import {findLastIndex, range} from 'ramda';

import {
  SectorResponseBody,
  useGetOccupiedSpacesQuery,
  VehicleSpaceResponseBody,
} from '@dms/api/warehouse';

import {suffixTestId, TestIdProps} from 'shared/web';

import {SectorButton} from './SectorButton';

interface SectorProps extends TestIdProps {
  sector: SectorResponseBody;
  isShowingFree: boolean;
  selectedNumber: number | undefined;
  occupiedSpace: VehicleSpaceResponseBody | undefined;
  onSpaceClick: (spaceNumber: number) => void;
}

export function Sector(props: SectorProps) {
  const lastElementRef = useRef<HTMLDivElement>(null);
  const [buttonWidth, setButtonWidth] = useState<number | undefined>();

  const {data: occupiedSpaces} = useGetOccupiedSpacesQuery({
    sectorId: props.sector.sectorId,
  });

  useLayoutEffect(() => setButtonWidth(lastElementRef.current?.clientWidth), [props.isShowingFree]);

  const spaces = range(1, props.sector.numberOfParkingSpaces + 1).map((space) => {
    const isSelected = props.selectedNumber === space;
    const isOccupied = occupiedSpaces?.some((occupiedSpace) => occupiedSpace.number === space);
    const isOriginalSelected =
      props.sector.sectorId === props.occupiedSpace?.sectorId &&
      space === props.occupiedSpace.number;

    return {
      title: `${props.sector.prefix}${space}`,
      occupant: occupiedSpaces?.find((occupiedSpace) => occupiedSpace.number === space)?.occupant,
      value: space,
      isSelected,
      isOccupied,
      isOriginalSelected,
      isHidden: !isSelected && !isOriginalSelected && props.isShowingFree && isOccupied,
    };
  });

  const lastShowedIndex = findLastIndex((x) => !x.isHidden, spaces);

  return (
    <VStack spacing={4}>
      <Text data-testid={suffixTestId('name', props)}>{props.sector.name}</Text>
      <HStack spacing={4} wrap>
        {spaces
          .filter((space) => !space.isHidden)
          .map((space, index) => (
            <div
              key={space.value}
              css={css`
                max-width: 100%;
                width: ${buttonWidth}px;
              `}
              ref={index === lastShowedIndex ? lastElementRef : undefined}
            >
              <SectorButton space={space} onSpaceClick={props.onSpaceClick} index={index} />
            </div>
          ))}
      </HStack>
    </VStack>
  );
}
